import {
  SUBMIT_COMPETITOR_PROFILE_V3_REQUEST,
  SUBMIT_COMPETITOR_PROFILE_V3_SUCCESS,
  SUBMIT_COMPETITOR_PROFILE_V3_FAILURE,
} from "../actions/competitorProfileV3Actions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitorProfileV3Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_COMPETITOR_PROFILE_V3_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_V3_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_V3_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default competitorProfileV3Reducer;
